import theme from '@styles/theme';
export default {
  sectionContainer: (count: number) => ({
    padding: count > 2 ? ['48px 0', '48px 0', '64px 24px', '64px 24px', '80px 10.15625vw'] : ['48px 0px', '48px 0px', '64px 0', '64px 0', '80px 0'],
    display: ['block', 'block', 'block', 'flex'],
    justifyContent: 'center',
    background: theme.rawColors.dirtyBlue300
  }),
  shoppingValueSectionContainer: (count: number) => ({
    display: 'flex',
    width: '100%',
    justifyContent: count > 2 ? 'space-between' : 'space-evenly',
    flexWrap: 'nowrap',
    columnGap: 24
  }),
  shoppingValueMobileContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    columnGap: 34,
    p: '0 34px'
  },
  shoppingValueContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: ['50%', '50%', '162px', '304px'],
    width: ['50%', '50%', '25%', '25%']
  },
  iconWrapper: {
    mb: '16px',
    display: 'flex'
  },
  text: {
    color: theme.rawColors.darkGrey700,
    textAlign: 'center',
    margin: '8px 0 0',
    fontSize: [theme.fontSizes.caption, theme.fontSizes.caption, theme.fontSizes.caption, theme.fontSizes.caption, theme.fontSizes.smallText],
    p: {
      fontSize: [theme.fontSizes.caption, theme.fontSizes.caption, theme.fontSizes.caption, theme.fontSizes.caption, theme.fontSizes.smallText]
    }
  },
  button: {
    mt: '16px'
  }
};